/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';

import { useDispatch } from 'react-redux';
import { EnsureAuthWrapper } from '../../common/EnsureAuthWrapper/EnsureAuthWrapper';
import { notaryAPI } from '../../../api/notary';
import { setCurrentUser } from '../../../actions/userAction';
import { usePermissions } from '../../../hooks/usePermissions';
import { get, isEqual } from '@utils/lodash';

export interface ParticipantRoomWrapperProps {
  children?: React.ReactNode;
}

export const LoginWrapper: React.SFC<ParticipantRoomWrapperProps> = ({ children }) => {
  const dispatch = useDispatch();
  const permissions = usePermissions();
  const ensureAuthenticated = async (pathname: string) => {
    try {
      await notaryAPI.auth.ping();
      const user = await notaryAPI.users.fetchCurrentUser();
      if (!isEqual(permissions, user.permissions)) {
        setCurrentUser(user)(dispatch);
      }
    } catch (e) {
      if (get(e, 'response.status') === 401) {
        await notaryAPI.auth.login(pathname);
      } else {
        throw e;
      }
    }
  };
  return <EnsureAuthWrapper ensureAuthenticated={ensureAuthenticated}>{children}</EnsureAuthWrapper>;
};
